module.exports = __webpack_public_path__ + "static/media/green-tick-icon.9e484975.svg";